/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import 'moment/locale/pt-br'
import {
  ModalContainer,
  CloseButton,
  Row,
  Icon,
  Col,
  SubLabel,
  StyledSelect,
  StyledMenuItem,
  CustomInputDateModal,
  TimeGrid,
  TimeBox,
  TimeLabel,
  StyledInput,
} from './styles'

// IMPORTS: traga os ACTION CREATORS com nomes distintos
import { getActivityAction } from '@stores/actions/event'
import { getRoomsAction } from '@stores/actions/room'

import CustomTextArea from '@components/inputs/textArea/customTextArea'
import PrimaryButton from '@components/inputs/button/primaryButton'
import { ModalBackground } from '@components/modal/styles'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

moment.locale('pt-br')

function ConfirmEventModal({
  onClose,
  onSave,
  setTitle,
  desc,
  setDesc,
  setStartTime,
  setEndTime,
  startTime,
  endTime,
  setRoom,
  setIsWeekly,
  editEvent,
  onEdit,
  isEditing,

  // <-- AQUI: receba as props ligadas ao dispatch
  getActivities,
  getRooms,
}) {
  const [activities, setActivities] = useState([])
  const [rooms, setRooms] = useState([])

  const [selectedValue, setSelectedValue] = useState('') // nome (activity)
  const [repeatEventSelected, setRepeatEventSelected] = useState('NR')
  const [locationSelected, setLocationSelected] = useState('') // id (room)

  const [startTimeDefault] = useState(new Date())
  const [endTimeDefault] = useState(moment().add(1, 'hour').toDate())

  const currentDate = moment(startTime !== '' ? startTime : new Date())
  const [inputValue, setInputValue] = useState(currentDate.format('DD/MM/YYYY'))
  const [inputError, setInputError] = useState(false)

  useEffect(() => {
    // preencher valores ao abrir
    if (isEditing && editEvent) {
      setStartTime(editEvent.start)
      setEndTime(editEvent.end)
      setTitle(editEvent.title?.name || editEvent.title || '')
      setDesc(editEvent.desc || '')
      setRoom(editEvent.room)
      setLocationSelected(editEvent.room?.id || '')
      setSelectedValue(editEvent.title?.name || editEvent.title || '')
    } else {
      if (startTime === '') setStartTime(startTimeDefault)
      if (endTime === '') setEndTime(endTimeDefault)
    }

    // carregar listas (DISPARCHANDO as actions!)
    // eslint-disable-next-line no-console
    console.debug('[ConfirmEventModal] carregando atividades e salas...')
    getActivities((list) => {
      setActivities(Array.isArray(list) ? list : [])
      // eslint-disable-next-line no-console
      console.debug('[ConfirmEventModal] atividades:', list)
    })
    getRooms((roomsList) => {
      const normalized = (roomsList || []).map((r) => ({ id: r.id, name: r.name, title: r.name }))
      setRooms(normalized)
      // eslint-disable-next-line no-console
      console.debug('[ConfirmEventModal] salas:', normalized)
    })
    // deps vazias: só na abertura do modal
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleDateTyping = (e) => {
    const input = e.target
    const cursor = input.selectionStart || 0
    const raw = e.target.value.replace(/[^0-9]/g, '')
    let formatted = raw
    if (raw.length >= 3) formatted = `${raw.slice(0, 2)}/${raw.slice(2)}`
    if (raw.length >= 5) formatted = `${raw.slice(0, 2)}/${raw.slice(2, 4)}/${raw.slice(4, 8)}`
    setInputValue(formatted.slice(0, 10))
    setTimeout(() => input.setSelectionRange(cursor, cursor), 0)
  }

  const handleDateBlur = () => {
    const newDate = moment(inputValue, 'DD/MM/YYYY', true)
    const endDate = moment(inputValue, 'DD/MM/YYYY', true)
    const currentYear = moment().year()
    const maxYear = 2030
    if (newDate.isValid() && newDate.year() >= currentYear && newDate.year() <= maxYear) {
      newDate.set({ hour: moment(startTime).hour(), minute: moment(startTime).minute() })
      endDate.set({ hour: moment(endTime).hour(), minute: moment(endTime).minute() })
      setStartTime(newDate.toDate())
      setEndTime(endDate.toDate())
      setInputError(false)
    } else {
      setInputError(true)
    }
  }

  const handleActivityChange = (e) => {
    const name = e.target.value
    setSelectedValue(name)
    const a = activities.find((x) => x.name === name)
    if (a) setTitle({ name: a.name, id: a.id })
  }

  const handleRepeatChange = (e) => {
    const v = e.target.value
    setRepeatEventSelected(v)
    setIsWeekly(v === 'SM')
  }

  const handleRoomChange = (e) => {
    const id = Number(e.target.value)
    setLocationSelected(id)
    const r = rooms.find((x) => Number(x.id) === id)
    setRoom({ id: r?.id, title: r?.name || r?.title })
  }

  const onTimeChange = (e, isStart) => {
    const time = e.target.value
    const base = moment(isStart ? startTime : endTime)
    const newTime = base.set({ hour: moment(time, 'HH:mm').hour(), minute: moment(time, 'HH:mm').minute() })
    if (isStart) setStartTime(newTime.toDate())
    else setEndTime(newTime.toDate())
  }

  const handleSave = () => {
    if (startTime > endTime) return
    if (isEditing) {
      const a = activities.find((x) => x.name === selectedValue)
      if (!a) return
      onEdit(editEvent.id, a.id)
      onClose()
      return
    }
    onSave()
  }

  const canSave = selectedValue !== '' && locationSelected !== '' && !inputError

  return (
    <ModalBackground>
      <ModalContainer>
        <CloseButton onClick={onClose}><span className="material-symbols-outlined">close</span></CloseButton>

        {/* Atividade */}
        <Row>
          <div />
          <Col>
            <StyledSelect
              value={selectedValue}
              onChange={handleActivityChange}
              displayEmpty
              renderValue={(v) => (v === '' ? <span>Selecione uma atividade</span> : v)}
            >
              {activities.map((a) => (
                <StyledMenuItem key={a.id} value={a.name}>{a.name}</StyledMenuItem>
              ))}
            </StyledSelect>
          </Col>
        </Row>

        {/* Data */}
        <Row>
          <Icon className="material-symbols-outlined">schedule</Icon>
          <Col>
            <CustomInputDateModal
              value={inputValue}
              onChange={handleDateTyping}
              onBlur={handleDateBlur}
              error={inputError}
            />
          </Col>
        </Row>

        {/* Início/Fim */}
        <Row>
          <div />
          <Col>
            <TimeGrid>
              <TimeBox>
                <TimeLabel>Início</TimeLabel>
                <StyledInput type="time" value={moment(startTime).format('HH:mm')} onChange={(e) => onTimeChange(e, true)} />
              </TimeBox>
              <TimeBox>
                <TimeLabel>Fim</TimeLabel>
                <StyledInput type="time" value={moment(endTime).format('HH:mm')} onChange={(e) => onTimeChange(e, false)} />
              </TimeBox>
            </TimeGrid>
          </Col>
        </Row>

        {/* Repetição */}
        <Row>
          <div />
          <Col>
            <StyledSelect value={repeatEventSelected} onChange={handleRepeatChange} displayEmpty>
              <StyledMenuItem value="NR">Não se Repete</StyledMenuItem>
              <StyledMenuItem value="SM">Semanal</StyledMenuItem>
            </StyledSelect>
          </Col>
        </Row>

        {/* Sala */}
        <Row>
          <Icon className="material-symbols-outlined">location_on</Icon>
          <Col>
            <SubLabel>Local</SubLabel>
            <StyledSelect
              value={locationSelected}
              onChange={handleRoomChange}
              displayEmpty
              renderValue={(v) => {
                if (v === '' || v === null) return <span>Selecione uma sala</span>
                const r = rooms.find((x) => Number(x.id) === Number(v))
                return r ? r.name || r.title : 'Selecione uma sala'
              }}
            >
              {rooms.map((r) => (
                <StyledMenuItem key={r.id} value={r.id}>{r.name || r.title}</StyledMenuItem>
              ))}
            </StyledSelect>
          </Col>
        </Row>

        {/* Descrição */}
        <Row style={{ alignItems: 'flex-start' }}>
          <Icon className="material-symbols-outlined">menu</Icon>
          <Col>
            <CustomTextArea
              onChange={(e) => setDesc(e.target.value)}
              value={desc}
              placeholder="Adicionar uma descrição"
              style={{ width: '94%' }}
            />
          </Col>
        </Row>

        <PrimaryButton disabled={!canSave} onClick={handleSave}>
          Salvar
        </PrimaryButton>
      </ModalContainer>
    </ModalBackground>
  )
}

// MAPEAR action creators -> props despacháveis
const mapDispatchToProps = (dispatch) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  bindActionCreators(
    {
      getActivities: getActivityAction,
      getRooms: getRoomsAction,
    },
    dispatch
  )

export default connect(null, mapDispatchToProps)(ConfirmEventModal)
